"use client"

import { toKebabCase } from "@/lib/string"
import { cn } from "@/lib/utils"
import React from "react"
import Link from "next/link"

interface TagProps {
  tag: string
  className?: string
  compact?: boolean
}

export function Tag({ tag, className = "", compact = false }: TagProps) {
  // Tag styles with improved visual integration - softer colors and better typography
  const baseStyles = cn(
    "inline-block rounded-full bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800/70 dark:text-gray-300 dark:hover:bg-gray-700/80 transition-all duration-200 font-medium",
    compact ? "px-2 py-1 text-xs" : "px-4 py-2 text-sm",
    className
  )

  // Convert tag to kebab-case for URL
  const kebabTag = toKebabCase(tag)

  // Ensure clicking the tag doesn't trigger parent click events
  const handleTagClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  // Link to the tag-specific page
  return (
    <Link
      href={`/search/tag/${kebabTag}`}
      className={baseStyles}
      onClick={handleTagClick}
    >
      {tag}
    </Link>
  )
}
